export default "/images/running.svg"